import { animate } from 'animejs';
import globalVar from '../utils/globalVar'

class Module00Specs {
  constructor() {
    let cache = {};
    let initFunc = () => {
      initCache();
      initSpecVars();
      initFromUrl();
      registerEvents();
    }

    let initCache = () => {
      cache.dropdown       = document.querySelectorAll('.module-00-specs .dropdown_title');
      cache.imageOptions   = document.querySelectorAll('.module-00-specs .image-option');
      cache.specVars       = document.querySelectorAll('.module-00-specs .specs-variations_container .specs-variation');
      cache.specVarBlocks  = document.querySelectorAll('.module-00-specs .specs.spec_var');
    };

    let initSpecVars = () => {
      cache.specVarBlocks.forEach(block => { block.style.display = 'none'; });
    };

    let initFromUrl = () => {
      const urlParams = new URLSearchParams(window.location.search);
      cache.specVarBlocks.forEach(block => {
        const param = block.getAttribute('data-url-param');
        if (!param) return;
        if (!urlParams.has(param) && ![...urlParams.values()].includes(param)) return;

        const section    = block.closest('.module-00-specs');
        const container  = block.parentElement;
        const mainSpecs  = section.querySelector('.specs.main');
        if (mainSpecs) mainSpecs.style.display = 'none';
        block.style.width   = container.offsetWidth + 'px';
        block.style.display = 'block';
        block.style.opacity = '1';
        container.style.height = block.offsetHeight + 'px';
        block.style.width = '';

        requestAnimationFrame(() => {
          animate(globalVar.scrollElement, {
            scrollTop: globalVar.scrollElement.scrollTop + section.getBoundingClientRect().top,
            duration: 600,
            ease: 'outQuad',
          });
        });
      });
    };

    let registerEvents = () => {
        for (let i = 0; i < cache.dropdown.length; i++) {
            cache.dropdown[i].addEventListener('click', toggleInfo);
        }
        for (let i = 0; i < cache.imageOptions.length; i++) {
            cache.imageOptions[i].addEventListener('click', toggleImage);
        }
        for (let i = 0; i < cache.specVars.length; i++) {
            cache.specVars[i].addEventListener('click', toggleSpecVar);
        }
    };

    let toggleInfo = function() {
        const dropdown = this.closest('.dropdown');
        
        if(!dropdown.classList.contains('active')) {
            const parent = dropdown.closest('.dropdown_container');
            const active = parent.querySelector('.dropdown.active');
            if (active) {
                active.classList.remove('active');
                animate(active.querySelector('.dropdown_content'), {
                    duration: 400,
                    height: 0,
                    ease: 'inOutCubic',
                    onComplete: function() {
                        active.querySelector('.dropdown_content').style.display = "none";
                    }
                });
            }

            dropdown.classList.add('active');
            const dropdown_content = dropdown.querySelector('.dropdown_content');
            dropdown_content.style.display = "block";
            dropdown_content.style.height = "auto";
            const height = dropdown_content.offsetHeight;
            dropdown_content.style.height = 0;

            animate(dropdown_content, {
                duration: 400,
                height: height,
                ease: 'inQuad',
            });
        } else {
            dropdown.classList.remove('active');
            animate(dropdown.querySelector('.dropdown_content'), {
                duration: 400,
                height: 0,
                ease: 'inOutCubic',
                onComplete: function() {
                    dropdown.querySelector('.dropdown_content').style.display = "none";
                }
            });
        }
    }

    let toggleImage = function() {
        const imageOption = this;
        const section     = imageOption.closest('.module-00-specs');
        const specsBlock  = imageOption.closest('.specs');
        if(!imageOption.classList.contains('active')) {
            const imageName = imageOption.getAttribute('data-image');
            const image = specsBlock.querySelector('.image-wrapper.' + imageName);
            const activeImage = specsBlock.querySelector('.image-wrapper.active');
            if (activeImage) {
                if (section.classList.contains('night-mode')) {
                    section.classList.remove('night-mode');
                }
                const $activeOption = specsBlock.querySelector('.image-option.active');
                if( $activeOption ) {
                    $activeOption.classList.remove('active');
                }
                activeImage.classList.remove('active');
                animate(activeImage, {
                    duration: 600,
                    opacity: [1,0],
                    ease: 'inSine',
                    onComplete: function() {
                        activeImage.style.display = "none";
                    }
                });
            }
            imageOption.classList.add('active');
            image.classList.add('active');
            image.style.display = "block";
            animate(image, {
                duration: 600,
                delay: 600,
                opacity: [0,1],
                ease: 'outSine'
            });
            if(imageName == 'night-image') {
                section.classList.add('night-mode');
            }
        } else {
            const image = specsBlock.querySelector('.image .main-image');
            const activeImageName = imageOption.getAttribute('data-image');
            const activeImage = specsBlock.querySelector('.image-wrapper.' + activeImageName);
            imageOption.classList.remove('active');
            activeImage.classList.remove('active');
            if (section.classList.contains('night-mode')) {
                section.classList.remove('night-mode');
            }
            animate(activeImage, {
                duration: 600,
                opacity: [1,0],
                ease: 'inSine',
                onComplete: function() {
                    activeImage.style.display = "none";
                }
            });
            image.classList.add('active');
            image.style.display = "block";
            animate(image, {
                duration: 600,
                delay: 600,
                opacity: [0,1],
                ease: 'outSine'
            });
        }
    }
    
    let toggleSpecVar = function() {
        const targetVar    = this.getAttribute('data-var');
        const section      = this.closest('.module-00-specs');
        const currentSpecs = this.closest('.specs');
        const targetSpecs  = section.querySelector('.specs.' + targetVar);
        const container    = currentSpecs.parentElement;

        if (!targetSpecs || currentSpecs === targetSpecs) return;

        // Measure target height before any DOM changes
        const containerWidth = container.offsetWidth;
        targetSpecs.style.cssText += ';display:block;opacity:0;width:' + containerWidth + 'px;';
        const newHeight = targetSpecs.offsetHeight;
        targetSpecs.style.display = 'none';
        targetSpecs.style.opacity = '';
        targetSpecs.style.width   = '';

        const oldHeight = currentSpecs.offsetHeight;
        container.style.height   = oldHeight + 'px';
        container.style.overflow = 'hidden';

        animate(globalVar.scrollElement, {
            scrollTop: globalVar.scrollElement.scrollTop + container.getBoundingClientRect().top,
            duration: 400,
            ease: 'outQuad',
        });

        animate(currentSpecs, {
            duration: 400,
            opacity: [1, 0],
            ease: 'inSine',
            onComplete: function() {
                currentSpecs.style.display = 'none';
                targetSpecs.style.display  = 'block';
                targetSpecs.style.opacity  = '0';

                // Reset back-mode in current specs
                const backOption  = currentSpecs.querySelector('.image-option[data-image="back-image"]');
                const backImage   = currentSpecs.querySelector('.image-wrapper.back-image');
                if (backOption) backOption.classList.remove('active');
                if (backImage)  { backImage.classList.remove('active'); backImage.style.display = 'none'; }

                // Sync night-mode state to target specs
                const isNightMode  = section.classList.contains('night-mode');
                const nightOption  = targetSpecs.querySelector('.image-option[data-image="night-image"]');
                const nightImage   = targetSpecs.querySelector('.image-wrapper.night-image');
                const mainImage    = targetSpecs.querySelector('.image-wrapper.main-image');

                if (isNightMode && nightOption && nightImage) {
                    nightOption.classList.add('active');
                    nightImage.classList.add('active');
                    nightImage.style.display = 'block';
                    nightImage.style.opacity = '1';
                    if (mainImage) { mainImage.classList.remove('active'); mainImage.style.display = 'none'; }
                } else {
                    if (!nightOption) section.classList.remove('night-mode');
                    if (nightOption) nightOption.classList.remove('active');
                    if (nightImage)  { nightImage.classList.remove('active'); nightImage.style.display = 'none'; }
                    if (mainImage)   { mainImage.classList.add('active'); mainImage.style.display = 'block'; mainImage.style.opacity = '1'; }
                }

                // Update URL param
                const urlParams  = new URLSearchParams(window.location.search);
                const prevParam  = currentSpecs.getAttribute('data-url-param');
                const nextParam  = targetSpecs.getAttribute('data-url-param');
                if (prevParam) urlParams.delete(prevParam);
                if (nextParam) urlParams.set(nextParam, '');
                const newSearch = urlParams.toString().replace(/=(?=&|$)/g, '');
                history.replaceState(null, '', window.location.pathname + (newSearch ? '?' + newSearch : ''));

                animate(container, {
                    height: [oldHeight, newHeight],
                    duration: 400,
                    ease: 'inOutQuad',
                });

                animate(targetSpecs, {
                    duration: 400,
                    opacity: [0, 1],
                    ease: 'outSine'
                });
            }
        });
    }

    initFunc();
  };
}
export { Module00Specs }